/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#card-first-responder {
  .time-of-arrival {
    width: 100%;
    margin-top: variables.$margin-large;
  }
}
